import { Icon, IconProps } from '@chakra-ui/react';

export const CompassSvg = ({
  size = 24,
  ...props
}: {
  size?: number;
} & IconProps): JSX.Element => {
  return (
    <Icon
      width={size}
      height={size}
      viewBox="0 0 157 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M118.327 92.0571L155.603 83.3503C156.205 83.2107 156.205 82.3031 155.603 82.1635L118.327 73.4616C116.979 66.904 114.235 60.895 110.449 55.8036L121.141 38.0558C121.47 37.5072 120.869 36.864 120.347 37.213L103.628 48.5628C98.8316 44.5385 93.1708 41.6263 86.9933 40.2001L78.7958 0.630338C78.6643 -0.00796416 77.8093 -0.00796416 77.6778 0.630338L69.4802 40.2001C63.3027 41.6313 57.642 44.5385 52.8456 48.5628L36.1265 37.213C35.6097 36.859 35.0037 37.5023 35.3372 38.0558L46.0292 55.8036C42.2429 60.895 39.4994 66.904 38.1512 73.4616L0.874809 82.1635C0.273501 82.3031 0.273501 83.2107 0.874809 83.3503L38.1512 92.0571C39.4994 98.6147 42.2382 104.624 46.0292 109.715L35.3372 127.463C35.0037 128.011 35.6097 128.655 36.1265 128.301L52.8456 116.951C57.642 120.975 63.3027 123.887 69.4802 125.314L77.6778 164.883C77.8093 165.522 78.6643 165.522 78.7958 164.883L86.9933 125.314C93.1708 123.882 98.8316 120.975 103.628 116.951L120.347 128.301C120.864 128.655 121.47 128.011 121.141 127.458L110.449 109.71C114.235 104.619 116.979 98.6097 118.327 92.0521V92.0571ZM102.759 110.693C101.603 111.835 100.382 112.897 99.0946 113.874C94.9043 117.056 90.0421 119.3 84.7901 120.327C82.662 120.741 80.4729 120.96 78.2368 120.96C76.0007 120.96 73.8115 120.741 71.6882 120.327C66.4361 119.295 61.574 117.051 57.3836 113.874C56.0964 112.902 54.8703 111.835 53.7147 110.693L50.9384 112.578C50.4216 112.927 49.8156 112.288 50.1491 111.74L51.9249 108.793C50.8491 107.566 49.8485 106.264 48.9277 104.898C45.9306 100.45 43.8166 95.2885 42.8489 89.7134C42.459 87.4544 42.2523 85.1306 42.2523 82.7569C42.2523 80.3832 42.4543 78.0594 42.8489 75.8054C43.8213 70.2302 45.9353 65.0689 48.9277 60.6208C49.8438 59.2544 50.8491 57.9529 51.9249 56.7261L50.1491 53.779C49.8156 53.2304 50.4216 52.5871 50.9384 52.9362L53.7147 54.8212C54.8703 53.6792 56.0964 52.617 57.3836 51.6396C61.574 48.4581 66.4361 46.2141 71.6882 45.1868C73.8162 44.7729 76.0054 44.5535 78.2368 44.5535C80.4682 44.5535 82.662 44.7729 84.7901 45.1868C90.0421 46.2191 94.9043 48.4631 99.0946 51.6396C100.382 52.6121 101.608 53.6792 102.759 54.8212L105.54 52.9362C106.057 52.5821 106.663 53.2254 106.334 53.774L104.558 56.7261C105.634 57.9529 106.634 59.2494 107.555 60.6158C110.543 65.0639 112.662 70.2252 113.634 75.8004C114.024 78.0594 114.231 80.3832 114.231 82.7519C114.231 85.1206 114.024 87.4494 113.634 89.7084C112.662 95.2835 110.548 100.445 107.555 104.893C106.639 106.259 105.639 107.561 104.558 108.783L106.334 111.735C106.667 112.283 106.061 112.927 105.54 112.573L102.759 110.688V110.693Z"
          fill="#DBDBDB"
        />
        <path
          d="M99.7802 82.7619C99.7802 95.3883 90.1358 105.626 78.2412 105.626C66.3466 105.626 56.7021 95.3883 56.7021 82.7619C56.7021 70.1355 66.3466 59.8977 78.2412 59.8977C90.1358 59.8977 99.7802 70.1355 99.7802 82.7619Z"
          fill="#DBDBDB"
        />
      </g>
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M97.356 95.3881C95.2702 99.577 84.5406 97.8964 73.3929 91.6381C62.2452 85.3797 54.898 76.9123 56.9838 72.7284C59.0696 68.5395 69.7992 70.2201 80.9468 76.4784C92.0945 82.7368 99.4417 91.2043 97.356 95.3881Z"
        fill="url(#paint0_radial_760_4516)"
      />
      <path
        d="M71.8995 79.0563L81.1399 76.7824L59.5304 68.4047L37.9209 60.022L71.8995 79.0563Z"
        fill="#C3C0C0"
      />
      <path
        d="M71.8995 79.0563L75.3429 88.4414L56.6319 74.2342L37.9209 60.022L71.8995 79.0563Z"
        fill="#756E6E"
      />
      <path
        d="M84.5832 86.168L75.3428 88.4419L96.9523 96.8246L118.566 105.202L84.5832 86.168Z"
        fill="#494A4D"
      />
      <path
        d="M84.5831 86.1675L81.1396 76.7825L99.8506 90.9947L118.566 105.202L84.5831 86.1675Z"
        fill="#62646A"
      />
      <path
        d="M81.3186 76.8824C85.0532 78.9768 86.782 83.2853 85.1801 86.5018C83.5781 89.7232 79.2516 90.6358 75.5169 88.5414C71.7822 86.4469 70.0534 82.1434 71.6507 78.922C73.2526 75.7005 77.5792 74.7879 81.3139 76.8824H81.3186Z"
        fill="#D0D0D0"
      />
      <defs>
        <radialGradient
          id="paint0_radial_760_4516"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.679 83.8798) rotate(29.3071) scale(23.2659 8.51741)"
        >
          <stop stopColor="#6B7680" />
          <stop offset="0.06" stopColor="#727C86" />
          <stop offset="0.16" stopColor="#889199" />
          <stop offset="0.25" stopColor="#949CA3" />
          <stop offset="0.32" stopColor="#A2A9B0" />
          <stop offset="0.43" stopColor="#B3B9BE" />
          <stop offset="0.48" stopColor="#BCC1C6" />
          <stop offset="0.65" stopColor="#D0D4D7" />
          <stop offset="0.81" stopColor="#EBEDEE" />
          <stop offset="0.95" stopColor="white" />
        </radialGradient>
      </defs>
    </Icon>
  );
};
